import React, { useEffect, useRef } from 'react';
import { BreakingNewsSection } from './breakingNewsSection';
import { getBreakingNewsStories } from '../../../common/actions/breakingNewsAction';
import { reduxConnect } from '../../../common';

const USCountryIso3 = 'usa';

interface BreakingNewsWrapperProps {
    breakingNewsTestCategory?: string;
    enableBreakingNewsTest: boolean;
    activeLocationId: string;
    countryIso3: string;
    getBreakingNewsStories: typeof getBreakingNewsStories;
}

const mapStoreStateToProps = (storeState: any) => {
    const { appState } = storeState || {};
    const { user, enableBreakingNewsTest, breakingNewsTestCategory } = appState?.appState || {};
    const { ActiveLocation } = user || {};

    return {
        activeLocationId: ActiveLocation?.Id,
        countryIso3: ActiveLocation?.Locality?.CountryIso3Code,
        enableBreakingNewsTest, 
        breakingNewsTestCategory 
    };
};

const mapDispatchToProps = {
    getBreakingNewsStories
};

export const BreakingNewsWrapper = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    countryIso3,
    activeLocationId,
    enableBreakingNewsTest, 
    breakingNewsTestCategory,
    getBreakingNewsStories
}: BreakingNewsWrapperProps) => {

    const prevActiveLocationId = useRef<string>('');

    useEffect(() => {
        if (activeLocationId 
            && countryIso3.toLocaleLowerCase() === USCountryIso3 
            && (!prevActiveLocationId.current 
                || prevActiveLocationId.current && prevActiveLocationId.current !== activeLocationId)) {
            if (enableBreakingNewsTest && breakingNewsTestCategory) {
                getBreakingNewsStories({ baseUrl: location.origin, category: breakingNewsTestCategory, count: 10 });   
            } else {
                getBreakingNewsStories({ baseUrl: location.origin, category: 'breakingnews-global', count: 10 }); // req path, category etc have defualts set in provider. 
            }
            prevActiveLocationId.current = activeLocationId;
        }
    }, [countryIso3, activeLocationId, enableBreakingNewsTest, breakingNewsTestCategory]);

    return (
        <BreakingNewsSection />
    );
});